export default "__VITE_ASSET__Du4iICcO__"